export default __webpack_public_path__ + "static/media/sale.f249d48c.jpg";